import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';

export interface StarterLimitationsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  limitations: string[];
  onConfirm: () => void;
}

export function StarterLimitationsModal({
  open,
  onOpenChange,
  limitations,
  onConfirm,
}: StarterLimitationsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" aria-hidden />
            Starter plan limitations
          </DialogTitle>
          <DialogDescription>
            Starter is owner-operated: families request bookings from your public catalogue without
            student or guardian logins. These workflows need Professional or higher — you can upgrade anytime.
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm text-slate-700 dark:text-slate-300">
          {limitations.map((item) => (
            <li key={item} className="flex gap-2">
              <span aria-hidden>•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Go back
          </Button>
          <Button type="button" onClick={onConfirm}>
            I understand — choose Starter
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
